import { useQueryFetch } from 'sonata-react-components';

import { GlobalCatch } from '@/components/common/GlobalCatch';
import { AggregatedReport, FootfallReport } from '@/components/driveToStore';
import { useDriveToStoreNavigation } from '@/components/driveToStore/common/hooks/useDriveToStoreNavigation';
import { getSharedReportForSession, isSharedReportSession } from '@/helpers/shareReport/shareReport.helper';
import { useGlobalStore } from '@/store/global';
import { getSession } from '@/store/global/session/selectors';
import { getUser } from '@/store/global/user/selectors.ts';

export const Catch = () => {
  return <GlobalCatch />;
};

export default function FootfallReportPage() {
  const { country, activePoiId, activeVenueIds, activeEntityIds, entityId, entityType } = useDriveToStoreNavigation();
  const user = useGlobalStore(getUser);
  const session = useGlobalStore(getSession);
  const isShared = isSharedReportSession(session);

  const { data: sharedReport, isLoading: isLoadingSharedReport } = useQueryFetch(
    ['sharedReportFullAccessContext', entityType, entityId],
    () => getSharedReportForSession(session),
    { enabled: isShared }
  );

  if (isShared && isLoadingSharedReport) {
    return null;
  }

  const userId = isShared ? String(sharedReport?.user ?? '') : user.toJSON().id!;
  const sharedReportFullAccess = !!sharedReport?.fullAccess;

  if (!activePoiId) {
    return (
      <AggregatedReport
        country={country}
        entityId={entityId}
        entityType={entityType}
        lineItemIds={activeEntityIds}
        sharedReportFullAccess={sharedReportFullAccess}
        userId={userId}
        venueIds={activeVenueIds}
      />
    );
  }

  return (
    <FootfallReport
      activePoiId={activePoiId}
      country={country}
      entityId={entityId}
      entityType={entityType}
      sharedReportFullAccess={sharedReportFullAccess}
      userId={userId}
    />
  );
}
